import React from "react";

const ChangePassword = (): JSX.Element => {
    return <div>ChangePassword</div>;
};

export default ChangePassword;
